import React from "react";
import { useTranslation } from "react-i18next";
import robotAI from "../../../assets/images/robot-ai.gif";

interface SpinnerScreenProps {
    children?: React.ReactNode;
    isShow?: boolean,
    textLoading?: string,
    style?: any,
    isAnimationText?: boolean,
    className?: string,
}

const SpinnerScreen: React.FC<SpinnerScreenProps> = ({ children, isShow, isAnimationText = true, textLoading = 'AI News is being generated and optimized!', style = {}, className = '' }) => {
    const { t, i18n } = useTranslation();

    return (
        <div className={!!isShow ? '' : 'd-none'} style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#fff',
            zIndex: 99,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            ...style,
        }}>
            <div className="position-relative text-center d-flex flex-column align-items-center justify-content-center">
                <img width="150" height="150" src={robotAI} alt={t(textLoading)} />
                <p className={`${isAnimationText ? 'loading-shimmer-pure-text-inverted' : ''} text-primary mb-0 ${className}`}>
                    {t(textLoading)}
                </p>
            </div>
        </div>
    );
};

export default React.memo(SpinnerScreen);
